export function generateCode(characters, length, characterCase) {
    const chars = characters.split(',');
    let cd = '';

    for (let i = 0; i < length; i++) {
        const char = Math.floor(Math.random() * chars.length)

        if (characterCase === 'upper') {
            cd += chars[char].toUpperCase();
        } else if (characterCase === 'random') {
            cd += Math.random() < 0.5 ? chars[char].toUpperCase() : chars[char];
        } else {
            cd += chars[char];
        }
    }

    return cd;
}
